module.exports = __webpack_public_path__ + "img/heineken.8e75a7b5.png";